import { Builder } from '@builder.io/react';

import UnstyledStateText from './unstyled-state-text';

Builder.registerComponent(UnstyledStateText, {
  name: 'UnstyledStateText',
  friendlyName: 'Unstyled State Text',
  inputs: [
    {
      name: 'content',
      type: 'string',
      friendlyName: 'Content',
      helperText:
        'Anything after a caret (^) will be in the accent color. {{state}} will be replace with the state name.',
    },
    { name: 'accentColor', type: 'color', friendlyName: 'Accent Color' },
    {
      name: 'fallbackState',
      type: 'string',
      friendlyName: 'Fallback Location',
    },
  ],
});
